module.exports = __webpack_public_path__ + "static/fonts/Fact-Light.bedb9b6.woff2";